// extracted by mini-css-extract-plugin
export default {"image":"PendingItemAdvancementName__image___obFhx","icon":"PendingItemAdvancementName__icon___TE5Hb","approved":"PendingItemAdvancementName__approved___urmAQ"};